module.exports = __webpack_public_path__ + "static/fitness-9faa93ed7720ca0d02b321a7435700b9.svg";